<template>
  <section>
    <div class="row">
      <div class="col-l-8 col-s-12">
        <h3 class="h1" v-html="productName"><!-- #58 --></h3>
        <p>
          <strong>
            {{ $t('substore.provider') }}:<!-- #59 -->
            <span v-html="providerName"><!-- #60 --></span>
          </strong>
        </p>
      </div>
      <div class="col-l-4 col-s-12 offset-top-1">
        <!-- #61 -->
        <div v-if="productLogoResourcePath" class="s-center-l-right">
          <img :src="'delegates/product/content/' + productLogoResourcePath" :alt="productLogoAlt" class="product-image" />
        </div>
      </div>
    </div>

    <hr />

    <p v-html="productDescription"><!-- #62 --></p>
  </section>
</template>

<script>
export default {
  name: 'OrderDescription',

  props: {
    product: {
      type: Object,
      required: true,
    },

    propertySuffix: {
      type: String,
      required: true,
    },
  },

  computed: {
    productName() {
      return this.product.texts.productName;
    },

    providerName() {
      return this.product.texts.providerName;
    },

    productDescription() {
      return this.product.texts[`productDescription${this.propertySuffix}`];
    },

    productLogoResourcePath() {
      return this.product.images[`productLogo${this.propertySuffix}ResourcePath`];
    },

    productLogoAlt() {
      return this.product.images[`productLogo${this.propertySuffix}Alt`];
    },
  },
};
</script>
